<p data-test="schedule-description">Every weekday at {{ schedule | timeWithTimeZone }}</p>
